export enum PerformanceEvalDialogViewMode {
    view = 1,
    create,
    edit,
    none
}
